
import React from 'react';
const CLS = 'reactAppointmentsCard';

const MODE = {
	FTF: 'face to face',
	ONLINE: 'online video call',
}
const renderItem = (head, text, buttonText, onClick = null) => {
	return (
		text ? (
			<div  className={`${CLS}-list mt-1 d-flex flex-column flex-md-row`}>
				<div className="flex-1">
					<span className={`${CLS}-item-head d-block text-dark80`}>{head}</span>
					<span className="h6 font-weight-normal">{text}</span>
				</div>
				{
					buttonText ? <button className={`${CLS}-item-btn btn btn-primary btn-sm mt-1 mt-md-0`} onClick={onClick}>
						{buttonText}
					</button>
					: null
				}
			</div>
		)
		: null
	)
};

const ReactAppointmentsCard = (props) => {
	const {
		// from api JSON data
		Image,
		Location,
		Name,
		Date,
		Type,
		Mode,
		Address,
		// custom props
		joinText,
		feedbackText,
		isUpcoming,
		// events
		onCancelClick,
		onEditClick,
		onJoinCallClick,
		onSetReminderClick,
		onFeedbackClick
	} = props;

	return (
		<div className={`${CLS} card mt-2 bg-light10`} >
			<div className="card-header bg-light10 d-flex">
				<div className={`${CLS}-img`}>
					<img src={Image.Src} alt={Image.Alt} />
				</div>
				<div className={`${CLS}-header-content`}>
					<p className={`${CLS}-Location mb-0 text-dark80`}>{Location}</p>
					<p className={`${CLS}-Name mb-0 text-blue`}>{Name}</p>
				</div>
			</div>
			<div className="card-body">
				{renderItem('Date and time', Date)}
				{renderItem('Service type', Type)}
				{renderItem('Mode', Mode, Mode.toLowerCase() === MODE.ONLINE ? (isUpcoming? joinText: feedbackText): '', isUpcoming? onJoinCallClick: onFeedbackClick)}
				{renderItem('Address', Address)}
			</div>
			{isUpcoming ? (
				<div className="card-footer bg-light10 d-flex flex-column flex-md-row">
					<div className="flex-1 d-flex justify-content-around justify-content-md-start">
						<button className="btn px-0 text-light-blue btn-sm font-weight-bold" onClick={onCancelClick}>Cancel</button>
						<button className="btn px-0 ml-2 text-light-blue btn-sm font-weight-bold" onClick={onEditClick}>Edit</button>
					</div>
					<button className={`${CLS}-reminder-btn btn btn-outline btn-sm mt-1 mt-md-0`} onClick={onSetReminderClick}>Set a reminder</button>
				</div>
				) : null
			}

		</div>
	);
};

ReactAppointmentsCard.defaultProps = {
	feedbackText: 'Feedback survey',
	isUpcoming: false,
	joinText: 'Join video call',
	onCancelClick: null,
	onEditClick: null,
	onFeedbackClick: null,
	onJoinCallClick: null,
	onSetReminderClick: null,
	Image: {
		Alt: "alt tag",
		Src: "data:image/svg+xml,%3Csvg version='1.1' id='Capa_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' width='45.532px' height='45.532px' viewBox='0 0 45.532 45.532' style='enable-background:new 0 0 45.532 45.532' xml:space='preserve'%3E%3Cg%3E%3Cpath d='M22.766,0.001C10.194,0.001,0,10.193,0,22.766s10.193,22.765,22.766,22.765c12.574,0,22.766-10.192,22.766-22.765 S35.34,0.001,22.766,0.001z M22.766,6.808c4.16,0,7.531,3.372,7.531,7.53c0,4.159-3.371,7.53-7.531,7.53 c-4.158,0-7.529-3.371-7.529-7.53C15.237,10.18,18.608,6.808,22.766,6.808z M22.761,39.579c-4.149,0-7.949-1.511-10.88-4.012 c-0.714-0.609-1.126-1.502-1.126-2.439c0-4.217,3.413-7.592,7.631-7.592h8.762c4.219,0,7.619,3.375,7.619,7.592 c0,0.938-0.41,1.829-1.125,2.438C30.712,38.068,26.911,39.579,22.761,39.579z'%3E%3C/path%3E%3C/g%3E%3C/svg%3E"  //#TODO: Update Image url
	}
};

export default ReactAppointmentsCard;
